import React from "react";
import ReactDOM from "react-dom";
import { Button } from "@truevault/aquilo";
import { Alert } from "@mui/material";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";

type UnpublishedChangesBannerProps = {
  onPublish: () => void;
  disabled?: boolean;
};
export const UnpublishedChangesBanner = ({
  onPublish,
  disabled,
}: UnpublishedChangesBannerProps) => {
  const mount = typeof document !== "undefined" ? document.getElementById("top-banner") : null;
  if (!mount) return null;

  return ReactDOM.createPortal(
    <Alert
      severity="info"
      icon={false}
      sx={{
        backgroundColor: "#F4F7FF",
        color: "#006296",
        fontWeight: 500,
        display: "block",
        padding: "0",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 24px",
        }}
      >
        <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <div style={{ height: "24px" }}>
            <ExclamationCircleIcon style={{ width: "24px", height: "24px", color: "#2DA0DD" }} />
          </div>
          <div>
            You have unpublished changes. If you leave this page without publishing, they will not
            be saved.
          </div>
        </div>
        <div className="tw-boundary">
          <Button color="info" onClick={onPublish} disabled={disabled}>
            Publish Changes
          </Button>
        </div>
      </div>
    </Alert>,
    mount,
  );
};
